import { useEffect, useRef } from "react";

import { client } from "@client";
import { MAX_PREFETCH_QUERIES, NODE_COUNT } from "@constants";
import { PortfolioPerformanceGraphQuery, PortfolioPerformanceGraphQueryVariables } from "@ctypes";
import { PORTFOLIO_PERFORMANCE_GRAPH } from "@graphql";
import { useUser } from "@hooks/user";

export const useGoalsOverviewPrefetch = () => {
  const called = useRef(false);

  const { beneficiaries } = useUser();

  useEffect(() => {
    if (!beneficiaries?.length || called.current) return;

    called.current = true;

    beneficiaries.forEach((beneficiary, index) => {
      if (index >= MAX_PREFETCH_QUERIES) return;

      const beneficiaryId = beneficiary?.id;

      if (beneficiaryId) {
        client.query<PortfolioPerformanceGraphQuery, PortfolioPerformanceGraphQueryVariables>({
          query: PORTFOLIO_PERFORMANCE_GRAPH,
          variables: {
            beneficiaryId,
            nodeCount: NODE_COUNT,
          },
        });
      }
    });
  }, [beneficiaries]);
};
